
import {
  IContractTemplateTreeItemForm,
  IDistributionResponse,
  TEMPLATE_TYPE,
} from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { connectTemplateTreeItems } from '../templateQueryItemsConnector';

export const digitalDistributionTemplateQueryToForm = (
  distribution: IDistributionResponse,
  lowestAvailableId?: string,
  disabledSelection = false,
  disabledRemove = false
): IContractTemplateTreeItemForm[] => {
  const [digitalDistribution] = connectTemplateTreeItems(
    {
      digitalDistribution: { ...distribution, position: 0 },
    },
    lowestAvailableId ?? '1'
  );

  const digitalDistributionForm: IContractTemplateTreeItemForm = {
    ...digitalDistribution,
    disabledSelection: disabledSelection,
    disabledRemove: disabledRemove,
  };

  return contractTemplateUtil.distribution.initialValues(
    TEMPLATE_TYPE.digitalDistribution,
    [digitalDistributionForm]
  );
};
